module.exports = __webpack_public_path__ + "static/img/tab-one.f02d6546.png";